<template>
  <div>
    <h2>Questionnaire</h2>

    <div class="row mt-4">
      <div :class="isModel === true ? 'col-sm-2' : 'col-sm-4'">
        <h3>Visibility</h3>

        <label
          style="cursor:pointer"
          for="visibleQuestionnaire">
          <input
            :checked="isVisible"
            style="cursor:pointer"
            id="visibleQuestionnaire"
            type="checkbox"
            @click="setVisiblity"
          > Visible
        </label>
      </div>

      <div v-if="isModel === true" class="col-sm-3">
        <h3>Model Field</h3>

        <label
          style="cursor:pointer"
          for="forceModel">
          <input
            id="forceModel"
            style="cursor:pointer"
            type="checkbox"
            :checked="isForceShow"
            @click="setForceModel"
            :title="messageForceModel"
          /> Force show field with autofill model.
        </label>
      </div>

      <div class="col-sm-4">
        <h3>Tags</h3>

        <search-select v-model="tags" @input="setTags" :taggable="true" :multiple="true" :options="tagsForm"/>
      </div>
    </div>

    <br>

    <div
      v-if="
        fieldGroupId !== undefined ||
        (
          fieldData &&
          fieldData.type === 'checkbox'
        ) ||
        (
          fieldData &&
          fieldData.type === 'select'
        )
      "
      style="padding: 14px;" class="row">
      <div class="col-12 pl-0 pr-0 mb-2">
        <div>
          <h3 class="float-left mb-0">Actions</h3>
          <button
            v-if="isAddAction === true"
            @click="addActionTag"
            style="margin-top: 10px;"
            class="btn btn-success float-right mt-n1">Add
          </button>
        </div>
      </div>
      <table class="table table-sm table-bordered table-striped">
        <thead>
          <tr>
            <th v-if="fieldGroupId || (fieldData && fieldData.type === 'checkbox')">Value</th>
            <th>Action</th>
            <th v-if="fieldGroupId !== undefined">Checkbox</th>
            <th v-if="fieldData && fieldData.type === 'select'">Option</th>
            <th>Tags</th>
          </tr>
        </thead>
        <tbody v-for="(action, index) in actionTags" :key="index">
          <tr>
            <td v-if="fieldGroupId || fieldData.type === 'checkbox'">
              <div class="dropdown">
                <button :class="action.value === 'off' ? 'btn btn-danger' : 'btn btn-success'" class="dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  {{ action.value }}
                </button>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                  <ul style="list-style:none;top:100px;">
                    <li style="margin-left:-40px">
                      <button @click="controlAction({
                        index,
                        type: 'value',
                        value: 'off'
                      })" class="btn btn-primary form-control form-control-sm">off</button>
                    </li>

                    <li style="margin-left:-40px">
                      <button @click="controlAction({
                        index,
                        type: 'value',
                        value: 'on'
                      })" class="btn btn-primary form-control form-control-sm">on</button>
                    </li>
                  </ul>
                </div>
              </div>
            </td>
            <td>
              <div class="dropdown">
                <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  {{ action.action }}
                </button>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                  <ul style="list-style:none;top:100px;">
                    <li style="margin-left:-40px">
                      <button @click="controlAction({
                        index,
                        type: 'action',
                        value: 'show'
                      })" class="btn btn-primary form-control">Show</button>
                    </li>

                    <li style="margin-left:-40px">
                      <button @click="controlAction({
                        index,
                        type: 'action',
                        value: 'hide'
                      })" class="btn btn-primary form-control">Hide</button>
                    </li>
                  </ul>
                </div>
              </div>
            </td>
            <td v-if="fieldGroupId || fieldData.type === 'select'" style="min-width: 400px;">
              <search-select
                v-if="fieldGroupId"
                :options="checkboxes"
                v-model="action.checkbox"
                label="label"
                @input="setTagsDb"
              />

              <search-select
                v-else
                :options="selectOptions"
                v-model="action.select"
                label="label"
                @input="setTagsDb"
              />
            </td>
            <td style="min-width: 300px;">
              <span>
                <search-select
                  :multiple="true"
                  :options="tagsForm"
                  v-model="action.tags"
                  @input="setTagsToAction({
                    tags: action.tags,
                    index
                  })"
                />
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import SearchSelect from '../searchSelect/SearchSelect.vue'

export default {
  name: 'questionnaire-tags',

  data () {
    return {
      tagsForm: [],
      tags: [],
      actionTags: [],
      selectedTags: {},
      isVisible: true,
      checkboxes: [],
      isAddAction: true,
      isForceShow: false,
      isModel: false,
      messageForceModel: 'Force to show field with model.',
      selectOptions: []
    }
  },

  components: {
    SearchSelect
  },

  props: {
    fieldGroupId: {
      type: String
    },

    fieldData: {
      type: Object
    },

    isGroupActions: {
      type: Boolean,
      default: false
    }
  },

  created () {
    if (this.fieldData) {
      if (this.fieldData.model !== '') this.isModel = true

      this.isVisible = this.fieldData.tagVisibled
        ? this.fieldData.tagVisible
        : true

      if (this.fieldData.forceShow === true) {
        this.isForceShow = true

        this.messageForceModel = 'Hide field with model.'
      }
    }
  },

  mounted () {
    if (this.fieldGroupId) {
      let checkboxGroup = JSON.parse(JSON.stringify(this.$store.state.templates[this.$store.state.currentTemplateName]['checkboxGroups'][this.fieldGroupId]))

      this.tags = checkboxGroup.tags ? checkboxGroup.tags : []

      Object.keys(checkboxGroup.fields).forEach(fieldKey => {
        if (checkboxGroup.fields[fieldKey].type === 'checkbox') {
          checkboxGroup.fields[fieldKey].label = checkboxGroup.fields[fieldKey].translations.en.label + ' ( ' + checkboxGroup.fields[fieldKey].id + ' )'
          this.checkboxes.push(checkboxGroup.fields[fieldKey])
        }
      })

      this.isVisible = checkboxGroup.tagVisible !== undefined ? checkboxGroup.tagVisible : true

      this.actionTags = this.$store.getters.getActionTags(this.fieldGroupId)
    } else if (this.fieldData && this.fieldData.type === 'select') {
      this.selectOptions = this.fieldData.choiceData
      this.actionTags = this.fieldData.actionTags
      this.tags = this.fieldData.tags
        ? JSON.parse(JSON.stringify(this.fieldData.tags))
        : []
    } else if (this.fieldData) {
      this.tags = this.fieldData.tags
        ? JSON.parse(JSON.stringify(this.fieldData.tags))
        : []

      this.actionTags = this.fieldData.actionTags
    }

    this.tagsForm = this.$store.getters.getFormTags()
  },

  methods: {
    setTags (e) {
      let tagAdded = e.pop()
      let isNew = true

      if (tagAdded !== undefined) {
        tagAdded = tagAdded.label !== undefined ? tagAdded.label : tagAdded

        this.tags.forEach(tag => {
          if (tag === tagAdded) isNew = false
        })

        if (isNew === true) {
          if (tagAdded !== undefined) {
            this.tags.push(tagAdded)

            this.setTagsDb()

            this.tagsForm = this.$store.getters.getFormTags()
          }
        }
      } else {
        this.isVisible = true

        this.deleteTag(0)
      }
    },

    deleteTag (index) {
      this.tags.splice(index, 1)

      this.setTagsDb()

      this.tagsForm = this.$store.getters.getFormTags()
    },

    editTag (index) {
      document.getElementById(index + 'inputTag').classList.remove('hide')
      document.getElementById(index + 'tag').classList.add('hide')
    },

    changeTag (index) {
      let newValue = document.getElementById(index + 'inputTag').value

      let tmpTags = []

      tmpTags = this.tags

      tmpTags[index] = newValue

      this.tags = []

      tmpTags.forEach(tag => {
        this.tags.push(tag)
      })

      document.getElementById(index + 'inputTag').classList.add('hide')
      document.getElementById(index + 'tag').classList.remove('hide')

      this.setTagsDb()

      this.tagsForm = this.$store.getters.getFormTags()
    },

    actions (payload) {
      if (payload.show === true) {
        document.getElementById(payload.index + 'deleteTag').classList.remove('hide')
        document.getElementById(payload.index + 'editTag').classList.remove('hide')
      } else {
        document.getElementById(payload.index + 'deleteTag').classList.add('hide')
        document.getElementById(payload.index + 'editTag').classList.add('hide')
      }
    },

    setTagsDb () {
      let checkboxGroup = null

      if (this.fieldGroupId) checkboxGroup = this.$store.state.templates[this.$store.state.currentTemplateName]['checkboxGroups'][this.fieldGroupId]

      if (this.fieldGroupId) {
        if (!checkboxGroup.tags) checkboxGroup.tags = []
        if (!checkboxGroup.actionTags) checkboxGroup.actionTags = []

        checkboxGroup.tags = this.tags
        checkboxGroup.actionTags = this.actionTags

        this.$store.commit('editFieldGroup', {
          index: this.fieldGroupId,
          name: checkboxGroup.name,
          label: checkboxGroup.title,
          help: checkboxGroup.desc,
          tags: checkboxGroup.tags,
          actionTags: checkboxGroup.actionTags,
          tagVisible: this.isVisible
        })
      } else if (Object.keys(this.fieldData).length > 0) {
        if (!this.fieldData.tags) this.fieldData.tags = []

        this.fieldData.tags = this.tags

        this.fieldData.actionTags = this.actionTags

        this.fieldData.tagVisible = this.isVisible

        this.$store.commit('setTemplateFieldPage', this.fieldData)

        let questionnaires = JSON.parse(JSON.stringify(this.$store.state.questionnaires))

        Object.keys(questionnaires[this.$store.state.currentTemplateName].data).forEach(fieldKey => {
          if (!questionnaires[this.$store.state.currentTemplateName].data[fieldKey].tags) {
            questionnaires[this.$store.state.currentTemplateName].data[fieldKey].tags = []
          }

          let fieldId = this.fieldData.fieldName !== undefined
            ? this.fieldData.fieldName
            : this.fieldData.id

          if (questionnaires[this.$store.state.currentTemplateName].data[fieldKey].fieldName === fieldId) {
            questionnaires[this.$store.state.currentTemplateName].data[fieldKey].tags = this.tags

            questionnaires[this.$store.state.currentTemplateName].data[fieldKey].actionTags = this.actionTags

            questionnaires[this.$store.state.currentTemplateName].data[fieldKey].tagVisible = this.isVisible

            if (this.fieldData.forceShow !== undefined) questionnaires[this.$store.state.currentTemplateName].data[fieldKey].forceShow = this.fieldData.forceShow
          }

          // Assign tags to field group fields
          if (
            questionnaires[this.$store.state.currentTemplateName].data[fieldKey].checkboxes &&
            Object.keys(questionnaires[this.$store.state.currentTemplateName].data[fieldKey].checkboxes).length > 0
          ) {
            let checkboxes = questionnaires[this.$store.state.currentTemplateName].data[fieldKey].checkboxes

            let changeFieldGroupFields = false

            Object.keys(checkboxes).forEach(fieldChKey => {
              if (!checkboxes[fieldChKey].tags) checkboxes[fieldChKey].tags = []

              let fieldId = this.fieldData.fieldName ? this.fieldData.fieldName : this.fieldData.id

              if (checkboxes[fieldChKey].id === fieldId) {
                changeFieldGroupFields = true

                checkboxes[fieldChKey].tags = this.tags

                checkboxes[fieldChKey].actionTags = this.actionTags

                checkboxes[fieldChKey].tagVisible = this.isVisible

                if (this.fieldData.forceShow) checkboxes[fieldChKey].forceShow = this.fieldData.forceShow

                questionnaires[this.$store.state.currentTemplateName].data[fieldKey].checkboxes = checkboxes
              }
            })

            if (changeFieldGroupFields) {
              this.$store.commit('editFieldGroup', {
                index: questionnaires[this.$store.state.currentTemplateName].data[fieldKey].fieldName,
                name: questionnaires[this.$store.state.currentTemplateName].data[fieldKey].name,
                label: questionnaires[this.$store.state.currentTemplateName].data[fieldKey].title,
                help: questionnaires[this.$store.state.currentTemplateName].data[fieldKey].desc,
                checkboxes: questionnaires[this.$store.state.currentTemplateName].data[fieldKey].checkboxes
              })
            }
          }
        })

        this.$store.commit('setQuestionnaires', questionnaires)
        this.$bus.emit('updateQuestionnaire')
      }

      setTimeout(() => {
        this.$store.dispatch('saveTemplate')
        this.$bus.emit('reloadQuestionnaire')
        this.initVisible()
      }, 400)
    },

    addActionTag () {
      this.isAddAction = false

      let objTag = {
        value: 'off',
        action: 'show',
        tags: []
      }

      if (this.fieldGroupId) objTag.checkbox = this.checkboxes[0]
      else objTag.select = this.selectOptions[0]

      if (this.actionTags === undefined) this.actionTags = []

      this.actionTags.push(objTag)
    },

    setTagsToAction (payload) {
      if (payload.tags.length === 0) this.actionTags.splice(payload.index, 1)

      this.isAddAction = true

      this.setTagsDb()
    },

    setVisiblity () {
      let isChecked = document.getElementById('visibleQuestionnaire').checked

      this.isVisible = isChecked

      this.setTagsDb()

      this.tagsForm = this.$store.getters.getFormTags()
    },

    initVisible () {
      let isVisible = true

      if (this.fieldGroupId !== undefined) {
        let questionnairesData = JSON.parse(JSON.stringify(this.$store.state.questionnaires[this.$store.state.currentTemplateName].data))

        Object.keys(questionnairesData).forEach(fieldKey => {
          if (questionnairesData[fieldKey].fieldName === this.fieldGroupId) {
            if (questionnairesData[fieldKey].tagVisible === false) isVisible = false
          }
        })
      } else if (Object.keys(this.fieldData).length > 0) {
        if (this.fieldData.tagVisible === false) isVisible = false
      }

      this.isVisible = isVisible
    },

    controlAction (payload) {
      this.actionTags[payload.index][payload.type] = payload.value

      this.setTagsDb()
    },

    setForceModel () {
      this.isForceShow = !this.isForceShow

      this.messageForceModel = this.isForceShow === true ? 'Hide field with model.' : 'Force to show field with model.'

      this.fieldData.forceShow = this.isForceShow

      this.setTagsDb()
    }
  }
}
</script>

<style lang="scss">
  .vs__selected {
    background-color: rgb(109, 184, 255) !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/questionnaires/QuestionnaireTags.vue